module.exports = __webpack_public_path__ + "img/icon-bad.498bf492.png";